import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SearchYourDraftFields } from '../../../features/feature-manage-drafts/models/md-search-your-draft.interface'
import { SearchProjectResult } from '../../../features/feature-search-projects/models/sp-result.interface'
import { BasicRequest } from '../../models/interfaces/basic-request.interface'
import { BasicResult } from '../../models/interfaces/basic-result.interface'
import { ConfigService } from '../../services/config.service'
import { LogService } from '../../services/log.service'

@Injectable({ providedIn: 'root' })
export class FeatureMYDService {
   private _cn = this.constructor.name
   private _httpClient = inject(HttpClient)
   private _logService = inject(LogService)
   private _configService = inject(ConfigService)

   searchDrafts(request: BasicRequest<SearchYourDraftFields>): Observable<BasicResult<SearchProjectResult[], BasicRequest<SearchYourDraftFields>>> {
      this._logService.info(this._cn, this.searchDrafts.name, this._logService.START)
      this._logService.info(this._cn, this.searchDrafts.name, 'search drafts request body: ', request)
      return this._httpClient.post<BasicResult<SearchProjectResult[], BasicRequest<SearchYourDraftFields>>>(
         `${this._configService.apiUrl}/projects/draft:search`,
         request
      )
   }

   getNumberOfYourDrafts(): Observable<number> {
      this._logService.info(this._cn, this.getNumberOfYourDrafts.name, this._logService.START)
      return this._httpClient.get<number>(`${this._configService.apiUrl}/projects/draft:count`)
   }
}
